import type { Progress as ProgressValue } from '@gazette/shared';

/** "3 of 5 have signed", with one pip per player so the room can feel the pace. */
export function Progress({ progress, label }: { progress: ProgressValue; label: string }) {
  return (
    <div class="progress" aria-live="polite">
      <span class="progress__pips" aria-hidden="true">
        {Array.from({ length: progress.total }, (_, index) => (
          <span class={index < progress.done ? 'on' : ''} />
        ))}
      </span>
      <span class="progress__label">{label}</span>
    </div>
  );
}
